import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';

const EmailStatsTable = ({ labels, data, title, subtitle }) => {
  return (
    <Card>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              <IntlMessages id={title} />
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id={subtitle} />
            </span>
          </div>
        </div>
      </div>
      <CardBody>
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={5}
          filterable={false}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultSorted={[
            {
              id: 'conversations',
              desc: true,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default EmailStatsTable;
